<script setup>
import { ShippingBoxIcon } from "@easy/ui/icons";
import moment from "moment";
defineProps({
    item: { type: Object },
    isSelected: { type: Boolean, default: false },
});

function formatActiveUntil(timezonedDate = "") {
    return moment(timezonedDate).format("YYYY-MM-DD HH:mm:ss");
}
</script>

<template>
    <div
        class="cursor-pointer w-full p-2.5 ct-bg-1 rounded-lg overflow-hidden flex items-center shadow-sm shadow-gray-900/5 ct-fg-4 space-x-2.5"
        :class="[
            isSelected ? 'ring-2 ct-ring-focus' : 'ring-1 ct-ring-1 group-hover:ct-ring-brand',
        ]"
    >
        <img
            v-if="item.photo_url"
            :src="item.photo_url"
            alt="Product image"
            class="flex-shrink-0 w-16 h-16 rounded object-cover"
        />
        <div
            v-else
            class="w-16 h-16 rounded flex items-center justify-center ct-bg-3 text-gray-500 dark:text-neutral-200"
        >
            <ShippingBoxIcon class="flex-shrink-0 w-6 h-6 ct-fg-4" />
        </div>

        <div class="flex-grow space-y-1 overflow-hidden relative">
            <p class="text-xs ct-text-2 absolute top-2 right-4" v-if="item.active_until">
                {{ formatActiveUntil(item.active_until) }}
            </p>
            <p class="text-sm font-medium ct-text-2 truncate">{{ item.name }}</p>
            <p class="text-xs ct-text-3 truncate">{{ item.description }}</p>
            <p class="text-xs font-medium ct-text-success">
                {{ item?.main_price?.price || "" }} {{ item?.main_price?.currency || "" }}
            </p>
        </div>
    </div>
</template>
